export enum SettingsPageTab {
  APPLICATION,
  USER,
  BU,
}
